import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import Links from '@components/ncFiles/components/links';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';

interface NCFileDetailsNCFileLinksProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const NCFileDetailsNCFileLinksComponent: FC<NCFileDetailsNCFileLinksProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  ncFileData,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Links isLoading={!ncFileData.wasLoaded} links={ncFileData?.data?.links ?? []} />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileLinks = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileLinksComponent);

export { NCFileDetailsNCFileLinks };
